import { render, staticRenderFns } from "./TheAdminUserActiveTab.vue?vue&type=template&id=3be8b3c4"
import script from "./TheAdminUserActiveTab.vue?vue&type=script&lang=js"
export * from "./TheAdminUserActiveTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports